import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { Button } from '@mssgme/ui';
import DragIcon from '@mssgme/ui/icons/drag.svg';
import styles from './MessengerItem.scss';

export default function MessengerItem({ data, definition, t }) {
    return (
        <li className={styles.listItem}>
            <div className={styles.messengerPane}>
                <Link
                    className={classNames(styles.messengerLink, { [styles.messengerLinkActive]: data && data.enabled })}
                    to={`/p/edit/messengers/${definition.messenger}`}
                >
                    <img src={definition.icon} alt={`${definition.name} icon`} />
                    <span className={styles.messengerLabel}>{definition.name}</span>
                </Link>
                {data && data.enabled ? (
                    <div
                        className={styles.dragHandle}
                        title={t('common:labels.dragTip')}
                        data-element="drag-handle"
                        style={{ pointerEvents: data ? 'auto' : 'none' }}
                    >
                        <DragIcon width="6" color={data ? '#000' : '#ccc'} />
                    </div>
                ) : (
                    <Button
                        tag={Link}
                        size="small"
                        rounded
                        to={`/p/edit/messengers/${definition.messenger}`}
                        className={styles.button}
                    >
                        {t('pageMessengers.add')}
                    </Button>
                )}
            </div>
        </li>
    );
}

MessengerItem.propTypes = {
    data: PropTypes.object,
    definition: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};
